
import {rzContainer} from 'razlet-ui';
import Breadcrumbs from './breadcrumbs.vue';
import Untranslated from './untranslated.vue';
import sideLinks from './side-links.vue';
import Headless from './template/headless.vue';
import NewsList from './template/news-list.vue';
import News from './template/news.vue';

export default {
  name: 'sulu-template',
  components: {
    rzContainer,
    Untranslated,
    Breadcrumbs,
    sideLinks,
    Headless,
    NewsList,
    News,
  },
  props: {
    sulu: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    withSideMenu: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showSideMenu() {
      return !this.isMobile && this.withSideMenu;
    },
  },
};
